import { createStore } from 'vuex';
export default createStore({
    state: {
        user: null,
        recordings: [],
        loading: false,
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user;
        },
        SET_RECORDINGS(state, recordings) {
            state.recordings = recordings;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        setUser({ commit }, user) {
            commit('SET_USER', user);
        },
        setRecordings({ commit }, recordings) {
            commit('SET_RECORDINGS', recordings);
        },
        setLoading({ commit }, loading) {
            commit('SET_LOADING', loading);
        },
    },
    getters: {
        isAuthenticated: (state) => !!state.user,
        user: (state) => state.user,
        recordings: (state) => state.recordings,
        loading: (state) => state.loading,
    },
});
